import styled from 'styled-components';

const Wrapper = styled.section`
  padding: 4em;
  background: papayawhip;
`;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/Wrapper.js